var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"contact_page"}},[_c('p',{staticClass:"tips"},[_vm._v("点击按钮，即可启动“微信”客户端联系在线客服 "),_c('span',{staticClass:"close",on:{"click":_vm.back}},[_c('img',{attrs:{"src":require("./img/icon_img21.png")}})])]),_c('span',{staticClass:"btn",on:{"click":function($event){return _vm.toKf()}}},[_vm._v("联系在线客服")])])
}
var staticRenderFns = []

export { render, staticRenderFns }